import { Component } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { SharedService } from '../../../app/services/shared.service';

@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss'],
})
export class NotAuthorizedComponent {
  constructor(
    private msalService: MsalService,
    private sharedService: SharedService
  ) { }

  logout() {
    sessionStorage.clear();
    this.sharedService.eraseEvent();
    this.msalService.logout();
  }
}
